import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import SelectField from '../../components/SelectField';
import NotePickerItem from '../../../../plugins/MentionPickerPlugin/components/NotePickerItem';

var DatabaseNotesField =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(DatabaseNotesField, _React$PureComponent);

  function DatabaseNotesField() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DatabaseNotesField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DatabaseNotesField)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onNewCellItem", function (note) {
      var _this$props = _this.props,
          recordKey = _this$props.record.key,
          columnKey = _this$props.column.key,
          database = _this$props.database;
      database.addNoteToField(recordKey, columnKey, note);
      database.activate();
    });

    _defineProperty(_assertThisInitialized(_this), "onRemoveCellItem", function (note) {
      var _this$props2 = _this.props,
          recordKey = _this$props2.record.key,
          columnKey = _this$props2.column.key,
          database = _this$props2.database;
      database.removeNoteFromField(recordKey, columnKey, note);
    });

    _defineProperty(_assertThisInitialized(_this), "getNotesFromQuery", function (query) {
      var _this$props3 = _this.props,
          recordKey = _this$props3.record.key,
          columnKey = _this$props3.column.key,
          database = _this$props3.database;
      return database.getNotesFromQuery(recordKey, columnKey, query);
    });

    _defineProperty(_assertThisInitialized(_this), "getCurrentNotes", function () {
      var _this$props4 = _this.props,
          recordKey = _this$props4.record.key,
          columnKey = _this$props4.column.key,
          database = _this$props4.database;
      return database.getFieldNotes(recordKey, columnKey);
    });

    _defineProperty(_assertThisInitialized(_this), "renderListItem", function (note, index) {
      var NoteLinkComponent = _this.props.NoteLinkComponent;
      return {
        wrapperProps: {
          key: note.id
        },
        child: React.createElement(NoteLinkComponent, {
          title: note.title,
          noteId: note.id,
          className: "flexbox flexbox-align-center"
        })
      };
    });

    _defineProperty(_assertThisInitialized(_this), "renderCellItem", function (note) {
      return {
        wrapperProps: {
          key: note.id
        },
        child: React.createElement(NotePickerItem, {
          note: note
        })
      };
    });

    return _this;
  }

  _createClass(DatabaseNotesField, [{
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          attributes = _this$props5.attributes,
          isFocused = _this$props5.isFocused,
          database = _this$props5.database,
          store = _this$props5.store,
          column = _this$props5.column,
          record = _this$props5.record,
          isActive = _this$props5.isActive;
      return React.createElement(SelectField, Object.assign({}, attributes, {
        tooltipMessage: 'Add notes',
        isFocused: isFocused,
        isActive: isActive,
        multiSelect: true,
        listItems: this.getCurrentNotes(),
        getCellItems: this.getNotesFromQuery,
        onNewCellItem: this.onNewCellItem,
        onRemoveCellItem: this.onRemoveCellItem,
        renderListItem: this.renderListItem,
        renderCellItem: this.renderCellItem,
        database: database,
        column: column,
        record: record,
        store: store
      }));
    }
  }]);

  return DatabaseNotesField;
}(React.PureComponent);

_defineProperty(DatabaseNotesField, "propTypes", {
  attributes: PropTypes.object,
  isFocused: PropTypes.bool,
  isActive: PropTypes.bool,
  record: PropTypes.object,
  column: PropTypes.object,
  field: PropTypes.object,
  database: PropTypes.object.isRequired,
  NoteLinkComponent: PropTypes.func,
  store: PropTypes.object
});

export { DatabaseNotesField as default };